import { Stack, ToggleButton } from "@mui/material"
import { useState, useEffect } from "react"
import PlusIcon from "@mui/icons-material/Add"
import MinusIcon from "@mui/icons-material/Remove"
import {
  preview,
  treatView,
  viewControlInTreatment,
  wasmModule,
} from "@/gluelayer"
import { useTheme } from "@mui/material/styles"
import { useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import ZoomInIcon from "../../assets/toptoolbar/zoomin.svg"
import ZoomOutIcon from "../../assets/toptoolbar/zoomout.svg"
import { ReactSVG } from "react-svg"
export const ZoomBar = ({ sx = {} }) => {
  const theme = useTheme()
  const options = [100, 200, 400]
  const [value, setValue] = useState(options[0])

  const {
    hasUploadSTLs,
    curCaseMode,
    openHistorySplitView,
    isCreateNewRefinement,
    currentTreatmentPlan,
    openReviewPrint,
    openLabelPreview,
    openUndercutPreview,
    openTrimPreview,
  } = useAppSelector((state: RootState) => state.udTreatService)

  useEffect(() => {
    if (!wasmModule.isFinishedOpencase) return
    setValue(100)
    console.log(
      "🚀 ~ useEffect ~ isCreateNewRefinement:",
      isCreateNewRefinement,
    )

    if (openHistorySplitView || isCreateNewRefinement) {
      treatView.SetUpdateSliderCB((zoomvalue) => {
        setValue(Math.round(zoomvalue * 100))
      })
    } else {
      viewControlInTreatment.setZoomCallbackInTreatment((curZoomVal) => {
        //   console.log("cur zoom value", Math.round(curZoomVal * 100))
        setValue(Math.round(curZoomVal * 100))
      })
    }
  }, [openHistorySplitView, isCreateNewRefinement, currentTreatmentPlan])

  useEffect(() => {
    if (preview.isInitPreview()) {
      preview.zoomWithValue(value / 100)
    }
    if (!wasmModule.isFinishedOpencase || !value) return

    if (openHistorySplitView || isCreateNewRefinement)
      wasmModule.treatView.ZoomAutomatic(value / 100)
    else viewControlInTreatment.zoomWithValueInTreatment(value / 100)
  }, [value])
  const handleSelectChange = (event) => {
    setValue(event.target.value)
  }

  useEffect(() => {
    if (!wasmModule.isFinishedOpencase) return
    viewControlInTreatment.setZoomCallbackInTreatment((curZoomVal) => {
      setValue(Math.round(curZoomVal * 100))
    })
  }, [wasmModule.isFinishedOpencase])

  useEffect(() => {
    if (!wasmModule.isFinishedOpencase && preview.isInitPreview()) {
      preview.setZoomCallback((curZoomVal) => {
        setValue(Math.round(curZoomVal * 100))
      })
    }
  }, [hasUploadSTLs])

  const handlePlusOrMin = (num) => {
    let newZoomValue = value + num
    newZoomValue = Math.min(Math.max(newZoomValue, 25), 400)
    setValue(newZoomValue)
  }
  const handlePlusOrMinPreview = (num: number) => {
    const prinMoudle = wasmModule.moduleManager.GetModulePrintSelection()
    if (prinMoudle && prinMoudle.ZoomByUI) {
      const result = prinMoudle.CalcCurRendererZoomRatio() + num
      const clampedResult = Math.min(Math.max(result, 0.25), 4)
      prinMoudle.ZoomByUI(clampedResult)
    }
  }
  const checkShowZoomBar = () => {
    if (curCaseMode === "NewCase") {
      if (hasUploadSTLs[0] || hasUploadSTLs[1]) return true
      else return false
    } else return true
  }
  return (
    checkShowZoomBar() && (
      <Stack
        sx={{
          height: 48,
          borderRadius: 2,
          backgroundColor: theme.transBkColor.light,
          boxShadow: 3,
          zIndex: 20,
          ...sx,
        }}
        direction={"row"}
      >
        <ToggleButton
          value={0}
          sx={{
            border: "none",
            borderRadius: "8px",
            "&:hover": {
              borderRadius: "8px",
            },
            "&.Mui-selected": {
              borderRadius: "8px",
            },
          }}
          onClick={() => {
            handlePlusOrMinPreview(-0.1)
          }}
        >
          <ReactSVG src={ZoomOutIcon} style={{ marginTop: 6 }}></ReactSVG>
        </ToggleButton>

        <ToggleButton
          value={1}
          sx={{
            border: "none",
            borderRadius: "8px",
            "&:hover": {
              borderRadius: "8px",
            },
            "&.Mui-selected": {
              borderRadius: "8px",
            },
          }}
          onClick={() => {
            handlePlusOrMinPreview(0.1)
          }}
        >
          <ReactSVG src={ZoomInIcon} style={{ marginTop: 6 }}></ReactSVG>
        </ToggleButton>
      </Stack>
    )
  )
}
